// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Price = require("./Price.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let PropertyPrice_price_graphql = require("../../../__generated__/PropertyPrice_price_graphql.bs.js");
let PropertyPrice_property_graphql = require("../../../__generated__/PropertyPrice_property_graphql.bs.js");
let PropertyPrice_propertyPrice_graphql = require("../../../__generated__/PropertyPrice_propertyPrice_graphql.bs.js");

let convertFragment = PropertyPrice_property_graphql.Internal.convertFragment;

let convertFragment$1 = PropertyPrice_price_graphql.Internal.convertFragment;

let convertFragment$2 = PropertyPrice_propertyPrice_graphql.Internal.convertFragment;

function PropertyPrice$FromPropertyPrice(props) {
  let __children = props.children;
  let className = props.className;
  let size = props.size;
  let children = __children !== undefined ? __children : null;
  let propertyPrice = RescriptRelay_Fragment.useFragment(PropertyPrice_propertyPrice_graphql.node, convertFragment$2, props.propertyPrice);
  switch (propertyPrice.__typename) {
    case "ExactPrice" :
      return JsxRuntime.jsxs(Price.make, {
        children: [
          propertyPrice.price.formatted,
          children
        ],
        size: size,
        className: className
      });
    case "PriceRange" :
      return JsxRuntime.jsxs(Price.make, {
        children: [
          propertyPrice.minPrice.formatted,
          " - ",
          propertyPrice.maxPrice.formatted,
          children
        ],
        size: size,
        className: className
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected price: ` + propertyPrice._0);
  }
}

let FromPropertyPrice = {
  make: PropertyPrice$FromPropertyPrice
};

function PropertyPrice$FromProperty(props) {
  let __children = props.children;
  let children = __children !== undefined ? __children : null;
  let property = RescriptRelay_Fragment.useFragment(PropertyPrice_price_graphql.node, convertFragment$1, props.property);
  return JsxRuntime.jsx(PropertyPrice$FromPropertyPrice, {
    propertyPrice: property.price.fragmentRefs,
    size: props.size,
    className: props.className,
    children: children
  });
}

function PropertyPrice$WithoutErrorBoundary(props) {
  let className = props.className;
  let size = props.size;
  let property = RescriptRelay_Fragment.useFragment(PropertyPrice_property_graphql.node, convertFragment, props.property);
  switch (property.__typename) {
    case "ForSalePropertyV5" :
      return JsxRuntime.jsx(PropertyPrice$FromProperty, {
        property: property.fragmentRefs,
        size: size,
        className: className
      });
    case "RentalPropertyV5" :
      return JsxRuntime.jsx(PropertyPrice$FromProperty, {
        property: property.fragmentRefs,
        size: size,
        className: className,
        children: "/month"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected member: ` + property._0);
  }
}

let WithoutErrorBoundary = {
  make: PropertyPrice$WithoutErrorBoundary
};

function PropertyPrice(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "price",
    children: JsxRuntime.jsx(PropertyPrice$WithoutErrorBoundary, {
      property: props.property,
      size: props.size,
      className: props.className
    })
  });
}

let make = PropertyPrice;

exports.FromPropertyPrice = FromPropertyPrice;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Price Not a pure module */
